const THIRTY_MINUTES_MS = 30 * 60 * 1000

// Our marketing site (fathom.ai) has a separate browser SDK implementation because it's a separate domain
// To help with user attribution, pass amplitude's identifiers are params so the marketing site can know
// that the user is still in the same session even though they came from the app.
// https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2#cross-domain-tracking
export function addAnalyticsToUrl(url: string): string {
  if (!window.amplitude) return url

  const deviceId = window.amplitude.getDeviceId()
  if (!deviceId) return url

  const newUrl = new URL(url)
  newUrl.searchParams.append('ampDeviceId', deviceId)

  const sessionId = window.amplitude.getSessionId()
  if (sessionId) {
    newUrl.searchParams.append('ampSessionId', sessionId)
  }

  newUrl.searchParams.append('ampTimestamp', String(Date.now() + THIRTY_MINUTES_MS))

  return newUrl.toString()
}
